var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.records && _vm.records.length > 0
    ? _c(
        "div",
        { staticClass: "table-row summary-row" },
        [
          _c(
            "div",
            {
              staticClass: "table-cell summary-label-cell",
              style: {
                minWidth: _vm.getColumnWidth("record-id") + "px",
                maxWidth: _vm.getColumnWidth("record-id") + "px",
              },
            },
            [_vm._v(_vm._s(_vm.$t("table.summary")))]
          ),
          _vm._v(" "),
          _vm._l(_vm.visibleFields, function (field, index) {
            return _c(
              "div",
              {
                key: field._id,
                staticClass: "table-cell",
                style: {
                  minWidth: _vm.getColumnWidth(field._id) + "px",
                  maxWidth: _vm.getColumnWidth(field._id) + "px",
                },
              },
              [
                field.fieldType === "dropdown"
                  ? [
                      _c(
                        "div",
                        { staticClass: "dropdown-summary" },
                        _vm._l(
                          _vm.getDropdownDistribution(_vm.records, field),
                          function (dist) {
                            return _c("div", {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: _vm.getDropdownTooltip(dist),
                                  },
                                  expression:
                                    "{ content: getDropdownTooltip(dist) }",
                                },
                              ],
                              key: dist.value,
                              staticClass: "summary-option-chip",
                              style: {
                                backgroundColor: dist.color,
                                flexGrow: dist.flexValue,
                              },
                              on: {
                                mouseover: function ($event) {
                                  return _vm.hoverOption(dist)
                                },
                                mouseleave: function ($event) {
                                  return _vm.leaveOption(dist)
                                },
                              },
                            })
                          }
                        ),
                        0
                      ),
                    ]
                  : _vm.isUserField(field)
                  ? [
                      _c("div", {
                        ref: "userChart",
                        refInFor: true,
                        staticClass: "pie-chart-summary",
                      }),
                    ]
                  : field.valueType === "number" ||
                    field.fieldType === "currency"
                  ? [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.getNumericTooltip(
                                  _vm.records,
                                  field
                                ),
                              },
                              expression:
                                "{ content: getNumericTooltip(records, field) }",
                            },
                          ],
                          staticClass: "numeric-summary",
                        },
                        [
                          _vm._v(
                            "\n                Sum: " +
                              _vm._s(_vm.getNumericSum(_vm.records, field)) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  : field.valueType === "date"
                  ? [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                content: _vm.getDateRangeTooltip(
                                  _vm.records,
                                  field
                                ),
                              },
                              expression:
                                "{ content: getDateRangeTooltip(records, field) }",
                            },
                          ],
                          staticClass: "date-summary-chip",
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.getShortDateRange(_vm.records, field)
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }